const { debounce } = window.BAO.Utils

class ProductDetail extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setStyleProperties()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'load', this.setStyleProperties.bind(this))

    this.listeners.add(
      window,
      'resize',
      debounce(this.setStyleProperties.bind(this), 100),
    )
  }

  setStyleProperties () {
    if (this.els?.preview?.element) {
      document.documentElement.style.setProperty(
        '--ProductDetail_Height',
        `${this.els.preview.element.clientHeight}px`,
      )
    }

    if (this.els?.media?.element) {
      window.setTimeout(() => {
        // Timeout ensures that any CSS transitions are finished running
        document.documentElement.style.setProperty(
          '--ProductDetail_MediaWidth',
          `${this.els.media.element.offsetWidth}px`,
        )
      }, 750)
    }
  }
}

if (!customElements.get('product-detail')) {
  customElements.define('product-detail', ProductDetail)
}
